import React from "react";
import { getColor } from "./getColor";
import { InvoiceIconType } from "./invoice.icon";

const TableIcon = ({ active }: InvoiceIconType) => {
  return (
    <svg width="20" height="20" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.89583 22.0622H21.1042C22.48 22.0622 23.6 20.9422 23.6 19.5664V3.27474C23.6 1.89893 22.48 0.778906 21.1042 0.778906H2.89583C1.52002 0.778906 0.4 1.89893 0.4 3.27474V19.5664C0.4 20.9422 1.52002 22.0622 2.89583 22.0622ZM1.55833 3.27474C1.55833 2.53743 2.15852 1.93724 2.89583 1.93724H21.1042C21.8415 1.93724 22.4417 2.53743 22.4417 3.27474V19.5664C22.4417 20.3037 21.8415 20.9039 21.1042 20.9039H2.89583C2.15852 20.9039 1.55833 20.3037 1.55833 19.5664V3.27474Z"
        fill={getColor(active)}
        stroke={getColor(active)}
        strokeWidth="0.2"
      />
      <path
        d="M0.979167 7.68724H23.0208C23.3406 7.68724 23.6 7.4278 23.6 7.10807C23.6 6.78834 23.3406 6.52891 23.0208 6.52891H0.979167C0.659438 6.52891 0.4 6.78834 0.4 7.10807C0.4 7.4278 0.659438 7.68724 0.979167 7.68724Z"
        fill={getColor(active)}
        stroke={getColor(active)}
        strokeWidth="0.2"
      />
      <path
        d="M0.979167 12.4783H23.0208C23.3406 12.4783 23.6 12.2188 23.6 11.8991C23.6 11.5794 23.3406 11.3199 23.0208 11.3199H0.979167C0.659438 11.3199 0.4 11.5794 0.4 11.8991C0.4 12.2188 0.659438 12.4783 0.979167 12.4783Z"
        fill={getColor(active)}
        stroke={getColor(active)}
        strokeWidth="0.2"
      />
      <path
        d="M0.979167 17.2712H23.0208C23.3406 17.2712 23.6 17.0118 23.6 16.6921C23.6 16.3723 23.3406 16.1129 23.0208 16.1129H0.979167C0.659438 16.1129 0.4 16.3723 0.4 16.6921C0.4 17.0118 0.659438 17.2712 0.979167 17.2712Z"
        fill={getColor(active)}
        stroke={getColor(active)}
        strokeWidth="0.2"
      />
      <path
        d="M6.15 21.4831C6.15 21.8028 6.40944 22.0622 6.72917 22.0622C7.0489 22.0622 7.30833 21.8028 7.30833 21.4831V7.10807C7.30833 6.78834 7.0489 6.52891 6.72917 6.52891C6.40944 6.52891 6.15 6.78834 6.15 7.10807V21.4831Z"
        fill={getColor(active)}
        stroke={getColor(active)}
        strokeWidth="0.2"
      />
      <path
        d="M11.4205 21.4831C11.4205 21.8028 11.6799 22.0622 11.9997 22.0622C12.3194 22.0622 12.5788 21.8028 12.5788 21.4831V7.10807C12.5788 6.78834 12.3194 6.52891 11.9997 6.52891C11.6799 6.52891 11.4205 6.78834 11.4205 7.10807V21.4831Z"
        fill={getColor(active)}
        stroke={getColor(active)}
        strokeWidth="0.2"
      />
      <path
        d="M16.692 21.4831C16.692 21.8028 16.9514 22.0622 17.2712 22.0622C17.5909 22.0622 17.8503 21.8028 17.8503 21.4831V7.10807C17.8503 6.78834 17.5909 6.52891 17.2712 6.52891C16.9514 6.52891 16.692 6.78834 16.692 7.10807V21.4831Z"
        fill={getColor(active)}
        stroke={getColor(active)}
        strokeWidth="0.2"
      />
    </svg>
  );
};

export default TableIcon;
